import {
  Box,
  HStack,
  Spinner,
  Text,
  VStack,
  useMediaQuery,
  Pressable
} from 'native-base';
import CryptoJS from 'crypto-js';
import { Svg } from 'react-native-svg';
import { COLORS } from '../../../utils/colors';
import { COMMONFONTSIZE } from '../../../utils/fonts';
import CommonHeading from '../../../components/headings';
import CustomButton from '../../../components/button';
import Reviews from '../../../containers/review';
import DividerLine from '../../../components/divider';
import ContainerCards from '../../../components/cards';
import Comments from '../../../containers/comments';
import { useEffect, useRef, useState } from 'react';
import CustomModal from '../../../components/modal';
import { RateExperienceModal } from './modalChildren';
import { MOBILE_VIEW_WIDTH } from '../../../utils/screens';
import { Toaster } from '../../../components/toaster';
import { hasPermission, statusMap } from '../../../utils/permission';
import { requestIconSVG, downloadIconSVG } from '../../../utils/svg';
import MobileModelSheet from '../../../components/actionSheet';
import { LoaderAnimation } from '../../../components/spinner';
import { setIsDownloading } from '../../../store/reducers/eventSlice';
import { useDispatch } from 'react-redux';
import { downloadReviewReportAPI } from '../../../api/apis/quicklinks';
import config from '../../../utils/config';

const ReviewDetails = ({
  eventsDetail,
  reviewFormData,
  updateWorkflow,
  reviews,
  approveReviewWorkflow,
  getReviews,
  getEventDetails,
  isLoading = true,
  scrollToTop = () => {}
}) => {
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const toaster = Toaster();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });
  const [reviewData, setReviewData] = useState({});
  const [totalReviewCount, setTotalReviewCount] = useState(0);
  const [totalRated, setTotalRated] = useState(0);
  const [existingUser, setExistingUser] = useState(false);
  const [pending, setPending] = useState(0);
  const [totalReview, setTotalReview] = useState([0, 0, 0, 0, 0]);
  const childref = useRef(null);
  const [forceRemount, setForceRemount] = useState(false);
  const [reviewsSortData, setReviewsSortData] = useState([]);

  useEffect(() => {
    if (reviewFormData) {
      setReviewData(reviewFormData);
    }
    if (reviews) {
      let rating = 0;
      let count = 0;
      let total = [0, 0, 0, 0, 0];
      let pending = 0;
      let userHasReview = false;
      
      reviews.map((review) => {
        if (review.status === 'pending') {
          pending = pending + 1;
        }
        if (
          review.status !== 'pending' &&
          review.status !== 'review_rejected'
        ) {
          count = count + 1;
          rating = rating + parseFloat(review.rating);
          total[Math.floor(review.rating) - 1] =
            total[Math.floor(review.rating) - 1] + 1;
        }
        if (review.added_by === userInfo.user_id) {
          userHasReview = true;
        }
      });
      
      // Update existingUser state based on whether user has any reviews
      setExistingUser(userHasReview);
      
      setReviewsSortData(
        reviews
          .filter(
            (review) =>
              review.added_by === userInfo.user_id &&
              review.status !== 'review_rejected'
          )
          .concat(
            reviews.filter(
              (review) =>
                review.added_by !== userInfo.user_id &&
                review.status !== 'review_rejected'
            )
          )
      );
      setPending(pending);
      let average = rating / count;
      average = parseFloat(average.toFixed(1));
      if (average > 5) {
        average = 5;
      }
      if (average) setTotalReviewCount(average);
      setTotalRated(count);
      setTotalReview(total);
    }
  }, [reviewFormData, reviews]);

  const openModal = () => {
    setForceRemount(!forceRemount);
    !MobileWindow && scrollToTop();
    setShowModal(true);
  };

  const closeModal = () => {
    setForceRemount(!forceRemount);
    setShowModal(false);
    setReviewData({
      added_by: '',
      approved_at: '',
      approved_by: '',
      current_step: '',
      event_id: '',
      rating: '',
      review: '',
      workflow_id: ''
    });
  };

  const downloadReviewReport = async () => {
    try {
      LoaderAnimation.show();
      dispatch(setIsDownloading(true));

      const response = await downloadReviewReportAPI(eventsDetail?._id);
      // Generate default filename
      const eventName = eventsDetail?.event_name;
      let filename = `${eventName}_reviews.xlsx`;

      if (response?.filename) {
        filename = response?.filename;
      }

      // Create download URL from blob
      const url = window.URL.createObjectURL(response.data);

      // Create a temporary link element and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Show success toaster
      toaster('Review Report downloaded successfully!', 'success', 'success');
    } catch (error) {
      toaster(
        error.message || 'Failed to download report. Please try again later.',
        'error',
        'error'
      );
    } finally {
      LoaderAnimation.hide();
      dispatch(setIsDownloading(false));
    }
  };

  const getStartDateFormat = (dateString) => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }
    function formatDate(date) {
      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate())
        ].join('-') +
        'T' +
        [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds())
        ].join(':') +
        '.' +
        '616838+00:00'
      );
    }
    const formattedDate = formatDate(date);

    return formattedDate;
  };

  const modalHeader = <Text>Rate Experience</Text>;
  const modalFooter = (
    <Box width={MobileWindow && '100%'}>
      <CustomButton
        onPress={async () => {
          let data = childref.current.onSubmitInput();
          reviewData.review = data.value;
          let payload = { ...reviewData };
          if (
            reviewData.review !== 0 &&
            reviewData.review.length > 0 &&
            reviewData.review.length > 5000
          ) {
            toaster(
              'Please enter review less than 5000 characters',
              'error',
              'error'
            );
            return;
          } else payload.review = data.value;
          if (!payload.rating || payload.rating === '') {
            toaster('Please provide rating', 'error', 'error');
            return;
          }

          if (payload.rating <= 3 && payload.review === '') {
            toaster('Please provide review', 'error', 'error');
            return;
          }

          LoaderAnimation.show();
          let dateTime = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }).format(new Date());

          payload['starts_at'] = getStartDateFormat(eventsDetail['from_date']);
          payload['ends_at'] = getStartDateFormat(eventsDetail['to_date']);
          payload.event_id = eventsDetail._id;
          payload.type = 'review';
          payload.added_at = dateTime;
          payload.added_by = userInfo.user_id;
          payload.added_employee_name = userInfo.first_name;
          payload.review = reviewData.review;
          delete payload['_id'];
          delete payload['workflow_id'];
          await updateWorkflow([payload], 'ADD_REVIEW', 'review');
          setExistingUser(true);
          LoaderAnimation.hide();
          closeModal();
        }}
        text='Submit'
        color={COLORS.WHITE_COLOR}
      />
    </Box>
  );

  return (
    <VStack
      bg={COLORS.WHITE_COLOR}
      space={3}
      borderRadius={'8px'}
      w={'100%'}
    >
      <Box
        py={4}
        px={4}
        width={'100%'}
      >
        {isLoading ? (
          <>
            <CommonHeading
              text='Reviews'
              fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
              fontWeight='600'
            />
            <Box
              mt={10}
              flex={1}
              alignItems='center'
              justifyContent='center'
            >
              <Spinner
                color={COLORS.THEME_COLOR}
                size='lg'
              />
            </Box>
          </>
        ) : (
          <>
            <HStack
              justifyContent={'space-between'}
              alignItems={'center'}
              pr={0}
            >
              <HStack
                alignItems={'center'}
                space={4}
              >
                <CommonHeading
                  text='Reviews'
                  fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                  fontWeight='600'
                />
                {/* Download Icon */}
                {userInfo.role === 'admin' && (
                  <Pressable onPress={downloadReviewReport}>
                    <Box>
                      <Svg
                        width={MobileWindow ? '20' : '24'}
                        height='20'
                        viewBox='0 0 24 24'
                      >
                        {downloadIconSVG}
                      </Svg>
                    </Box>
                  </Pressable>
                )}
              </HStack>
              {!existingUser && statusMap.indexOf(eventsDetail.status) >= 2 && (
                <CustomButton
                  textColor={COLORS.THEME_COLOR}
                  bgColor='none'
                  text='RATE NOW'
                  py={2}
                  px={2}
                  onPress={openModal}
                />
              )}
              {/* )} */}
            </HStack>
            <Box
              mr={'9.5rem'}
              width={MobileWindow && '100%'}
            >
              <Reviews
                overallAverage={totalReviewCount}
                overallRating={totalRated}
                totalReview={totalReview}
                progressBarWidth='100%'
              />
            </Box>
          </>
        )}
      </Box>
      {reviewsSortData.length > 0 && (
        <>
          <DividerLine direction='horizontal' />
          <VStack
            alignItems={'center'}
            px={4}
            space={2}
          >
            {reviewsSortData.map((item, ind) => {
              if (
                ((hasPermission('REVIEW_LIST') &&
                  item.status !== 'review_rejected') ||
                  (!hasPermission('REVIEW_LIST') &&
                    (item.status === 'review_approved' ||
                      (item.status === 'pending' &&
                        userInfo.user_id === item.added_by)))) &&
                item.status !== '' &&
                item.status !== 'review_rejected' &&
                ind < 3
              ) {
                return (
                  <ContainerCards
                    background={COLORS.ATTACHMENT_FILES_COLOR}
                    width='100%'
                    height='auto'
                    boxShadow='none'
                  >
                    <Comments
                      showAll={false}
                      getReviews={getReviews}
                      getEventDetails={getEventDetails}
                      approveReviewWorkflow={approveReviewWorkflow}
                      reviewPayload={item}
                      stars={item.rating}
                      comments={item.review}
                      approval={true}
                      scrollToTop={scrollToTop}
                    />
                  </ContainerCards>
                );
              }
            })}
          </VStack>
          {reviewsSortData.length > 0 && reviewsSortData.length > 3 && (
            <HStack
              py={6}
              space={MobileWindow ? 2 : 6}
              px={4}
              direction={MobileWindow ? 'column' : 'row'}
              justifyContent='center'
              alignItems='center'
            >
              {/* {reviews.length - pending > 5 && ( */}
              <a
                style={{ textDecoration: 'none' }}
                href='/event-detail/all-review-detail'
              >
                <CustomButton
                  isOutline
                  text='Read all'
                  textColor={COLORS.BLACK_COLOR}
                  bgColor={COLORS.BLACK_COLOR}
                  borderRadius='50px'
                  width='fit-content'
                  py={3}
                />
              </a>
              {/* )} */}
              {/* {hasPermission("REVIEW") && pending > 20 && ( */}
              {hasPermission('REVIEW') && pending > 2 && (
                <a
                  style={{ textDecoration: 'none' }}
                  href='/event-detail/new-review-detail'
                >
                  <CustomButton
                    isOutline
                    endIcon={requestIconSVG}
                    text='View New Request'
                    textColor={COLORS.BLACK_COLOR}
                    bgColor={COLORS.BLACK_COLOR}
                    borderRadius='50px'
                    width='fit-content'
                    py={3}
                    px={2}
                  />
                </a>
              )}
            </HStack>
          )}
        </>
      )}
      {!MobileWindow ? (
        <CustomModal
          isOpen={showModal}
          onClose={closeModal}
          header={modalHeader}
          body={
            <RateExperienceModal
              eventName={eventsDetail.event_name}
              reviewData={reviewData}
              setReviewData={setReviewData}
              childref={childref}
              forceRemount={forceRemount}
            />
          }
          footer={modalFooter}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={modalHeader}
          body={
            <RateExperienceModal
              eventName={eventsDetail.event_name}
              reviewData={reviewData}
              setReviewData={setReviewData}
              childref={childref}
              forceRemount={forceRemount}
            />
          }
          footer={modalFooter}
        />
      )}
    </VStack>
  );
};

export default ReviewDetails;
